export default __webpack_public_path__ + "static/media/Bromley.343e4722.jpg";